import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { MatSort } from '@angular/material/sort';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import {
  SaleRequestsSearchFields,
  SaleRequestsTableFields,
} from 'src/app/models/sales/sales.model';
import { SaleMemberRequests } from '../../models/sales/sale-member-request.model';
import { MatDataSource } from '../../shared-new/util/mat-datasource';

export class SaleRequestsDataSource extends MatDataSource<SaleMemberRequests> {
  public constructor(data: SaleMemberRequests[], sort: MatSort) {
    super(data, sort);
    this.setFilterPredicate();
  }

  private sortOn: string;

  public setSortOn(sortOn: string) {
    this.sortOn = sortOn;
  }




  public applyDefaultSort() {
    if (this.sort) {
      this.sort.active = 'memberName'; // Set default sorting
      this.sort.direction = 'asc';
      this.sort.sortChange.emit(this.sort);
    }
  }

  setFilterPredicate(): void {
    this.filterPredicate = (request: SaleMemberRequests, filterValue: string = '') => {
      return 'memberName,clinic,emailAddress,mobile,access,status,comments'
        .split(',')
        .some((key) => {
          return (
            request[key as keyof SaleMemberRequests] &&
            new RegExp(filterValue.trim().toLowerCase(), 'gi').test(
              request[key as keyof SaleMemberRequests]
            )
          );
        });
    };
  }

  clearFilter(): void {
    this.filter = '';  // Clear the filter value
    this.filteredData = [...this.data];  // Reset the filtered data to the original data
    this._updateChangeSubscription();  // Trigger data refresh
  }


 
}
